import type { IconSvgObject } from './types';

const RadioButtonIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RadioButtonIcon;
